import React from 'react'
import 'src/components/Relays/Details/sections/Summary.css'
import { RelayDetailModel } from 'src/constants/DataModels'
import { formatTime } from 'src/constants/ConversionUtils'
import { ExplorerTxHashLink } from 'src/components/shared/ExplorerTxHashLink'
import { BlockchainWithIcon } from 'src/components/shared/BlockchainWithIcon'

type Props = {
  title: string
  data: RelayDetailModel
}

const Events: React.FC<Props> = ({ title, data }) => {
  const {
    events
  } = data
  const sortedEvents = events ? [...events].sort((a, b) => parseInt(a.block_time) - parseInt(b.block_time)) : []
  return (
    <div>
      <h4 className="section-title">{title}</h4>
      <div className="summary-content">
        <table>
          <thead>
          <tr>
            <th>Name</th>
            <th>Chain</th>
            <th>Tx</th>
            <th>Height</th>
            <th>Created</th>
          </tr>
          </thead>
          <tbody>
          {sortedEvents && sortedEvents.map(event => (
            <tr key={event.id}>
              <td>{event.name}</td>
              <td>
                <BlockchainWithIcon blockchain={event.blockchain} />
              </td>
              <td>
                <ExplorerTxHashLink blockchain={event.blockchain} hash={event.tx_hash} />
              </td>
              <td>{event.block_height}</td>
              <td>{formatTime(new Date(parseInt(event.block_time)))}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Events
